import { apiGet, authenticatedFetch } from '@/shared/api/apiClient';

export interface NotificationDto {
  id: string;
  title: string;
  message: string;
  notificationType: string;
  referenceId: string | null;
  isRead: boolean;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationListDto {
  items: NotificationDto[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export const notificationService = {
  async getNotifications(page = 1, pageSize = 20): Promise<NotificationListDto> {
    return apiGet<NotificationListDto>(
      `/notifications?page=${page}&pageSize=${pageSize}`
    );
  },

  async getUnreadCount(): Promise<{ count: number }> {
    return apiGet<{ count: number }>('/notifications/unread-count');
  },

  async markAsRead(id: string): Promise<void> {
    await authenticatedFetch(`/notifications/${id}/read`, { method: 'PATCH' });
  },

  async markAllAsRead(): Promise<void> {
    await authenticatedFetch('/notifications/read-all', { method: 'PATCH' });
  },
};
